var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stepper"},[_c('transition',{attrs:{"name":_vm.transition,"mode":"out-in"}},[_c('keep-alive',[_c(_vm.steps[_vm.step-1],{tag:"component",on:{"next":_vm.next,"back":_vm.back}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }